module.exports = __webpack_public_path__ + "img/等级快速回升-小.4cd1fe51.png";